import {useEffect, useState} from "react";

function Modal(params) {


    useEffect(() => {
        let shadowOld = document.querySelector('.modal-backdrop')
        if (shadowOld) {
            shadowOld.remove()
        }
        if (params.visible) {
            document.body.classList.add('modal-open')
            let shadow = document.createElement('div');
            shadow.classList.add('modal-backdrop')
            shadow.classList.add('fade')
            shadow.classList.add('show')
            document.body.append(shadow);
        } else {
            document.body.classList.remove('modal-open')
        }
    }, [params.visible])

    const handleHide = () => params.onHide()

    return (
        <div className={"modal fade vertical-align-middle " + (params.visible ? 'show d-block' : '')}
             tabIndex="-1" role="dialog">
            <div className="modal-dialog  animated" role="document">
                <div>
                    <button onClick={handleHide} className="btn-close theme-close" type="button"
                            aria-label="Закрыть">&nbsp;</button>

                    <div className="modal-body">
                        <div className="card">
                            <div className="p-25">
                                <h3>{params.title}</h3>
                                <div className={'p-t-30'}>
                                {params.children}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Modal